<script lang="ts">
    import { Toaster as UpstreamToaster } from '#lib/components/ui-shadcn-svelte/sonner/index.ts';
    import type { ToasterProps as SonnerProps } from 'svelte-sonner';

    let { ...restProps }: SonnerProps = $props();
</script>

<UpstreamToaster {...restProps} />

<style>
    /* Move the close button off the top-left corner, where it collides with the accent left border. */
    :global([data-sonner-toast] [data-close-button]) {
        left: auto !important;
        right: 0 !important;
        transform: translate(-25%, 25%) !important;
    }

    /* Per-type accent + tint strength. --color-popover is the toast surface
       (white in light, card in dark), so mixing toward it keeps tints correct
       in both themes. */
    :global([data-sonner-toast][data-type='success']) {
        --toast-accent: var(--color-success);
        --toast-tint: 10%;
    }
    :global([data-sonner-toast][data-type='error']) {
        --toast-accent: var(--color-destructive);
        --toast-tint: 10%;
    }
    :global([data-sonner-toast][data-type='info']),
    :global([data-sonner-toast][data-type='loading']) {
        --toast-accent: var(--color-info);
        --toast-tint: 10%;
    }
    :global([data-sonner-toast][data-type='warning']) {
        --toast-accent: var(--color-warning);
        --toast-tint: 13%;
    }

    :global([data-sonner-toast][data-type='success']),
    :global([data-sonner-toast][data-type='error']),
    :global([data-sonner-toast][data-type='info']),
    :global([data-sonner-toast][data-type='loading']),
    :global([data-sonner-toast][data-type='warning']) {
        background: color-mix(in srgb, var(--toast-accent) var(--toast-tint), var(--color-popover)) !important;
        color: var(--color-foreground) !important;
        border-color: color-mix(in srgb, var(--toast-accent) 35%, var(--color-popover)) !important;
        border-left: 4px solid var(--toast-accent) !important;
    }

    :global([data-sonner-toast][data-type='success'] [data-content]),
    :global([data-sonner-toast][data-type='error'] [data-content]),
    :global([data-sonner-toast][data-type='info'] [data-content]),
    :global([data-sonner-toast][data-type='loading'] [data-content]),
    :global([data-sonner-toast][data-type='warning'] [data-content]) {
        margin-left: 0.5rem;
    }

    :global([data-sonner-toast][data-type='success'] [data-icon]),
    :global([data-sonner-toast][data-type='error'] [data-icon]),
    :global([data-sonner-toast][data-type='info'] [data-icon]),
    :global([data-sonner-toast][data-type='loading'] [data-icon]),
    :global([data-sonner-toast][data-type='warning'] [data-icon]) {
        color: var(--toast-accent);
    }

    :global([data-sonner-toast][data-type='success'] [data-title]),
    :global([data-sonner-toast][data-type='error'] [data-title]),
    :global([data-sonner-toast][data-type='info'] [data-title]),
    :global([data-sonner-toast][data-type='loading'] [data-title]),
    :global([data-sonner-toast][data-type='warning'] [data-title]) {
        color: color-mix(in srgb, var(--toast-accent) 70%, var(--color-foreground));
    }

    /* Quiet close button: no fill at rest so it can't read as a second
       control against the type icon; tints toward the accent on hover. */
    :global([data-sonner-toast][data-type='success'] [data-close-button]),
    :global([data-sonner-toast][data-type='error'] [data-close-button]),
    :global([data-sonner-toast][data-type='info'] [data-close-button]),
    :global([data-sonner-toast][data-type='loading'] [data-close-button]),
    :global([data-sonner-toast][data-type='warning'] [data-close-button]) {
        background: transparent !important;
        border-color: transparent !important;
        color: color-mix(in srgb, var(--toast-accent) 45%, var(--color-muted-foreground)) !important;
    }
    :global([data-sonner-toast][data-type='success'] [data-close-button]:hover),
    :global([data-sonner-toast][data-type='error'] [data-close-button]:hover),
    :global([data-sonner-toast][data-type='info'] [data-close-button]:hover),
    :global([data-sonner-toast][data-type='loading'] [data-close-button]:hover),
    :global([data-sonner-toast][data-type='warning'] [data-close-button]:hover) {
        background: color-mix(in srgb, var(--toast-accent) 16%, transparent) !important;
        color: var(--toast-accent) !important;
    }
</style>
